import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../providers/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let islogin;
    this.auth.currentLoginStatus.subscribe(status => islogin = status);
    console.log("this.auth.isLogedin",islogin)
    if (islogin) {
      return true;
    }else{
      this.router.navigate(['/']);
      return false;
    }
      
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/auth/auth.guard.ts